import { generateId } from "../sdk/sdk";
const tips=[
    "There are tons of easter eggs in CMD; Try to find them all",
    "Did you know Boston is also called Beantown? Just me? oh...",
    "I actually have a youtube! Please subscribe, I want to buy new cymbals for my drums but I have a bank balance of $-2.59",
    "Are you reading these?",
    "Ancient Greece used to elect public officials with beans! Another reason to love them",
    "Pythogoras hated beans. Stupid, robe wearing triangle guy; he doesn't have the right to an opinion",
    "Beans on toast are good, I don't care what you say",
    "British people are very scary",
    "run 'secret' in DOS; I dare you",
    "You know this project is open source? yeah, you can fuck it up in any way you want",
    "I spent 4 hours on this update please follow my socials",
    "Half the sh*t here is like an bean-themed aldi version of actual apps",
    "Tell your friends about Beansite! (I need money)",
    "Adsense rejected me :(",
    "pringles",
    "Lorem ipsum dolor sit amet",
    "Beans",
    "Hello, World!",
    "scrotum :P",
    "Sub to my yt pls",
    "balls",
    "Sorry about loading speeds, this project is HUGE!!",
    "beans beans beans. jessie ate some beans. he was happy, happy, happy that he ate some beans",
    "kurt cobian once wrote a song about beans (yes, he was sober)",
    "Hi",
    "Hola",
    "Fuck Google Adsense im switching to Adinplay",
    "Maybe ill get ads some day. if i do, i promise i wont spam. im not that greedy",
    "i think you should be in class, buddy",
    "skibidi",
    "skibidi toilet",
    "sigma alpha male",
    "skibidi toilet sigma alpha male livvy dunne and baby gronk fanum tax rizz ohio",
    "im slowly losing all braincells",
    "sometimes you need to close a door to open a window",
    "my brother said im on the spectrum",
    "dont call me selfish, i aint sharin",
    "this 60/40 isnt working. i want a 100 of your time. your mine",
    "remember, if yall wants game scroll to the bottom of BeanPowered I do requests yk",
    "js ask me for games and ill add em.",
    "WHAT THE FUCK IS A KILOMETER",
    "Some profound text goes here",
    "Pro tip: don't add cement to your bread. it's softer if you use yeast. thank me later",
    "478868574082066804",
    "Hrmm",
    "As seen on TV!",
    "May contain nuts",
    "Uses Vite/React/Redux/Sass (No, I don't touch grass)",
    "No, I don't touch grass",
    "1337",
    "Open-Source!",
    "9% bug free!",
    "help",
    "i haven't slept in 2 months",
    "My chemicial coochie juice",
    "chemicial coochie juice",
    "moster",
    "e",
    "Nothing to see here!",
    "im so fucking done with this",
    "Finally got rid of the god-forsaken codebase of beansite 95 and I couldn't be happier.",
    "im freeeee~",
    "sleep deprivations getting to my ass",
    "i cant believe it took so long to get here",
    "im so fucking proud. this project. its complete. ive fixed the bugs. ive overcome the problems. feels like part of me is finally complete",
    "thanks for playing yall",
    "I WANT ADS! FUCK ADSENSE I WANT MY FUCKING ADS",
    "yk the beansite xp sdk is rly easy to use. yall can literally make ur own beansites.",
    "just bought ANOTHER monitor (i still dont enough enough)",
    "'should i cop?' - me, to rajeh",
    "the best things in life are free. Beansite is free, therfore, beansite is the best",
    "beansite classic coming ~ 10/1",
    "man im thirsty asf",
    "why am i thirsty asf?",
    "i need water",
    "im so thirsty",
    "i barely ever touch the 'tips.js' file, so when new drops, its like jesus' second coming",
    ()=>{try{return generateId(10)}catch{return "RnhPMlBiZlFqVw=="}},
    "console.log();",
    "document.getElementById();",
    "i listened to the sky under the sea 166 times this week :skull:",
    "if yall like coding in js, please help me mantain beansite. i cant keep doing this",
    "apperently yall are reading these, so hi",
    "i cant spell for shit man",
    "the day vercel gets blocked is the day i transfer",
    "bringus",
    "im bored asf rn",
    "goob",
    "https://github.com/Beansite-Dev/beansite-xp/",
    "https://github.com/Beansite-Dev/",
];
export default tips;